import * as React from 'react'
import PropTypes from 'prop-types'

export const ProductShortTitle = product => {
  const hasShortName = product.short_name
  const hasBrandAndModel = product.brand && product.model
  if (!hasShortName && !hasBrandAndModel) {
    return product.title
  }
  if (!hasBrandAndModel) {
    return product.short_name
  }
  return product.brand
}

const getProductTitleParts = ({ product, category, showRef = true }) => {
  if (!product) {
    return { title: '', sku: '' }
  }
  const hasBrandAndModel = product.brand && product.model
  // if (!product.brand && !product.model && !category) {
  //   return { title: product.title, sku: product.sku }
  // }
  if (
    (product?.brand || '').toLowerCase() === 'estate jewelry' ||
    (product?.brand || '').toLowerCase() === ''
  ) {
    return {
      featured: product.jewelry_type || product.item_category || category?.name || product.item_type,
      title: product.title,
      sku: product.sku,
    }
  }
  if (!product.brand && category?.name) {
    return {
      featured: category.name,
      title: product.title,
      sku: product.sku,
    }
  }

  if (!hasBrandAndModel) {
    return {
      featured: product.brand,
      featured2: product.jewelry_type || product.item_category || category?.name || product.item_type,
      title: product.title,
      sku: product.sku,
    }
  }
  const metal = product.head_metal || product.case_material || ''
  const cleanNickname = (product={}) => {
    const { nickname='', brand = '', model = '', model_no = '' } = product
    let raw = (nickname||'').trim()
    if (!raw) return ''

    const parts = [brand, model, model_no]
        .filter(Boolean)
        .map(s => s.trim().toLowerCase())
        // strip longer first to avoid partial overlaps
        .sort((a, b) => b.length - a.length)

    // run it multiple times to remove all parts from the start
    let found = true
    let lowered = raw.toLowerCase()
    while (found) {
      found = false
      for (const part of parts) {
        // must be at start and followed by at least one whitespace char
        if (lowered.startsWith(part) && /\s/.test(lowered[part.length] || '')) {
          // remove the exact slice
          raw = raw.slice(part.length).replace(/^\s+/, '') // trim leading WS after removal
          lowered = raw.toLowerCase()
          found = true
          break // restart loop after a successful strip
        }
      }
    }
    return raw.trim()
  }
  return {
    featured: product.brand,
    featured2:
      product.item_category === 'Pocket Watch'
        ? ''
        : (product.item_type !== 'Watch' && product.jewelry_type !== 'Other'
            ? product.jewelry_type
            : null) ||
          product.item_category ||
          category?.name ||
          product.item_type,
    title: (
      <>
        <nobr className=" w-full block truncate leading-none">
          <span className="uppercase">{product.model}</span>
          {product.nickname && <span className="uppercase">&nbsp;{cleanNickname(product)}</span>}
          {showRef && product.model_no ? ' / Ref. ' + product.model_no : ''}
        </nobr>
        {/* <span className="leading-none"> */}
        {/* <nobr className="uppercase ">{product.model} </nobr>
          {showRef && <nobr className="inline-block "> / Ref. {product.model_no} </nobr>}
          {product.model_no && <nobr className="inline-block "> / Ref. {product.model_no} </nobr>} */}
        {/* </span> */}
        <span className="block overflow-hidden text-lg line-clamp-1">
          {product.case_size_mm && product.case_size_mm + 'mm' + (metal && ', ')}
          {metal}{' '}
        </span>
      </>
    ),
    sku: product.sku,
  }
}

const ProductTitle = ({ product, category, showRef = true }) => {
  // console.log('ProductTitle', product, category, showRef)
  const { featured, featured2, title } = getProductTitleParts({ product, category, showRef })
  if (!featured) return <b>{title}</b>
  return (
    <div className="text-gray-500 leading-none lg:text-black lg:leading-tight">
      <b className="block md:text-2xl font-black uppercase my-1 text-black">
        {featured} {featured2}
      </b>
      {title}
    </div>
  )
}

export const ProductGridTitle = ({ product }) => {
  const handleCopyAndPreventRedirect = event => {
    // Prevent the default link behavior
    event.preventDefault()

    // Handle the copying
    navigator.clipboard
      .writeText(event.target.dataset.clipboardText)
      .then(() => {
        console.log('Text successfully copied!')
      })
      .catch(err => {
        console.error('Unable to copy text:', err)
      })
  }

  const sku =
    typeof window !== 'undefined' &&
    window &&
    window.location &&
    window.location.search &&
    window.location.search.indexOf('sku') > -1 
      ? (<button 
        onClick={handleCopyAndPreventRedirect} 
        data-clipboard-text={product.sku}
        className="my-2 font-bold cursor-copy underline underline-offset-4 decoration-red-600">SKU: {product.sku}</button>) 
      : null

  const { featured, featured2, title } = getProductTitleParts({
    product,
    category: null,
    showRef: false,
  })
  if (!featured) return <b>{title}</b>
  return (
    <h2 className={'text-center h-full w-full px-2 text-gray-600 text-sm sm:text-base'}>
      <b className="block h-auto max-h-16 font-black uppercase line-clamp-3 lg:line-clamp-2">
        {featured || '&nbsp;'} {featured2}
      </b>
      <div className="px-1 whitespace-normal line-clamp-2 break-words">{title}</div>
      {sku} </h2>
  )
}
ProductGridTitle.propTypes = {
  product: PropTypes.shape({
    name: PropTypes.string.isRequired,
    categories: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string.isRequired,
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      })
    ),
    urlPath: PropTypes.string.isRequired,
    sku: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    small_image: PropTypes.object.isRequired,
    item_type: PropTypes.string,
    item_category: PropTypes.string,
    jewelry_type: PropTypes.string,
    model_no: PropTypes.string,
    nickname: PropTypes.string,
    case_size_mm: PropTypes.number,
    thumbnail: PropTypes.object.isRequired,
    brand: PropTypes.string,
    model: PropTypes.string,
    price: PropTypes.number,
    special_price: PropTypes.number,
    qty: PropTypes.number,
  }),
}

ProductTitle.propTypes = {
  product: PropTypes.shape({
    title: PropTypes.string.isRequired,
    short_name: PropTypes.string,
    brand: PropTypes.string,
    model: PropTypes.string,
    model_no: PropTypes.string,
    nickname: PropTypes.string,
    case_size_mm: PropTypes.number,
    case_material: PropTypes.string,
  }).isRequired,
  category: PropTypes.shape({
    name: PropTypes.string.isRequired,
  }),
  showRef: PropTypes.bool,
}
ProductShortTitle.propTypes = {
  product: PropTypes.shape({
    title: PropTypes.string.isRequired,
    short_name: PropTypes.string,
    brand: PropTypes.string,
    model: PropTypes.string,
    model_no: PropTypes.string,
    nickname: PropTypes.string,
    case_size_mm: PropTypes.number,
    case_material: PropTypes.string,
  }).isRequired,
}

export default ProductTitle
